import { TextField } from '@material-ui/core'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  getProductItem
} from '../../action'
import { RoundItem, TextFieldWithLabel, ShopingCard } from '../../components'
import './style.scss'
//const cors = ['Preto', 'Branco', 'Cinza', 'Azul']
//const packs = ['2AA', '1A', '2A', '3A', '4A', '5A', '6A', '7A', '8A', '9A', '10A', '11A', '12A', '14A', '16A', '18A', '20A', '24A']
//const pays = ['160 DIAS', '130 DIAS']

class ProductItem extends Component {
  item = {}

  componentDidMount() {
    
    this.props.getProductItem(this.props.history.location.pathname.split('/')[2])
    //console.log('hi');
    //console.log(this.props.history.location.pathname.split('/')[2])
  }
  
  /* cors = (element) => {
    if (element.COR_CODIGO !== '') {
      element.map(cores => {
        return {
         
        };
      });
    } else {
      return {
         
      };
    }
  };  */

  render() {
    const { products: { productItem } } = this.props
    
    let item = [];
    let cors = [];
    let packs = [];
    let sizes = [];
    let pays = [];
    let delivers = [];
    if (this.props.products.productItem.productItem !== undefined) {
      console.log(this.props.products.productItem)
      item = this.props.products.productItem.productItem[0];
      cors = this.props.products.productItem.productItemColor;
      packs = this.props.products.productItem.productItemPacks;
      sizes = this.props.products.productItem.productItemSize;
      pays = this.props.products.productItem.productItemPay;
      delivers = this.props.products.productItem.productItemDeliver;
      //console.log(this.props.products)
    }
    
    return (
      <div className="product-item-page">
        <div className="photo">
          <div className="small-photos">
            <div className="small-photo" style={{ backgroundImage: `url(../../images/no-image-icon.png)` }}></div>
            <div className="small-photo" style={{ backgroundImage: `url(../../images/no-image-icon.png})` }}></div>
          </div>
          <div className="large-photo" style={{ backgroundImage: `url(../../images/no-image-icon.png)` }}></div>
        </div>
        <div className="information">
          <div className="title">{item?.title}</div>
          <div className="sub-info">
            <div>Fornecedor: {item?.fornecedor}</div>
          </div>
          <div className="sub-info">
            <div>Referência: {item?.id}{item?.mat_cor}</div>
            <div>{`R$ ${Number(item?.preco_produto).toFixed(2)} / R$ ${Number(item?.preco_venda).toFixed(2)}`}</div>
          </div>
          <div className="line" />
          <div className="sub-title">COR</div>
          <div className="cors">
            {
              cors.map((cor, index) => (<RoundItem content={cor} key={index} />))
            }
          </div>
          <div className="line" />
          <div className="sub-title">PACK</div>
          <div className="packs">
            {
              packs.map((pack, index) => (<RoundItem content={pack} key={index} />))
            }
          </div>
          <div className="line" />
          <div className="sub-title">TAMANHO</div><br/>
          <div className="content-center">
            {
              sizes.map((option, index) => (<TextFieldWithLabel label={option.tamanho} value={option.size} key={index} disabled/> ))
            }
          </div>
          <div className="line" />
          <div className="sub-title">FORMA PAGAMENTO</div><br/>
            
            <TextFieldWithLabel select label="Escolha uma opção">
              {pays.map((option, index) => (
                <option key={index} value={option.descricao}>
                  {option.descricao}
                </option>
              ))}
            </TextFieldWithLabel>

          <div className="line" />
          <div className="sub-title">DATA DE ENTREGA</div><br/>
            <TextField select label="Escolha uma opção">
                {delivers.map((option, index) => (
                  <option key={index} value={option.data} >
                    {option.data}
                  </option>
                ))}
            </TextField>
          <div className="line" />
          <div className="products-page" >
            <div className="card-lists" style={{width: "100%"}}>
              {
                Array.isArray(productItem) && productItem.map((element, index) => (
                  <ShopingCard {...element} key={index} onClick={() => this.props.history.push(`/productitem/${element.ref}`)} />
                ))
              }
            </div>
          </div>
        </div>
        
      </div>
    )
    
  }
}



const mapStateToProps = ({ products }) => ({
  products
})


export default connect(mapStateToProps, {
  getProductItem
})(ProductItem)


